import { ZANICHELLI_IDP_PINGINTERVAL } from '../config';
import { SET_USER_ANONYMOUS } from './auth';
import { instanceBase as axios } from '../lib/axios';

export const HEARTBEAT_START = 'HEARTBEAT_START';
export const HEARTBEAT_SUCCESS = 'HEARTBEAT_SUCCESS';
export const HEARTBEAT_ERROR = 'HEARTBEAT_ERROR';

export function heartbeat() {
    if (ZANICHELLI_IDP_PINGINTERVAL) {
        return async (dispatch) => {
            dispatch({ type: HEARTBEAT_START });

            try {
                const resp = await axios.get(`/session/sso/ping`);

                dispatch({
                    type: HEARTBEAT_SUCCESS,
                    payload: { status: resp.status },
                });
            } catch (error) {
                if (error?.response?.status < 500) {
                    dispatch({ type: HEARTBEAT_ERROR, payload: { status: error?.response?.status } });
                    // Resetta l'utente nello state di auth
                    dispatch({ type: SET_USER_ANONYMOUS });
                }
            }
        };
    }
}
